'use client';

import { __spreadArray } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { MobileSelectMode } from '../types/index.js';
import { SELECT_EMPTY_OPTION_ID } from '../Utils/constants.js';
import { usePrevious } from '../Utils/hooks.js';
import FullScreenModal, { FullScreenModalMode } from './FullScreenModal/index.js';
import styles from './MobileSelect.module.css.js';

// Empty value may also refer as Select All option
var EMPTY_VALUE_ID = SELECT_EMPTY_OPTION_ID;
/**
 * MobileSelect Component
 * A Functional Component using Hooks
 *
 * @param props
 */
var MobileSelect = function (props) {
    var _a, _b;
    var _c = props.title, title = _c === void 0 ? 'Select' : _c, _d = props.options, options = _d === void 0 ? [] : _d, _e = props.mode, mode = _e === void 0 ? MobileSelectMode.Single : _e, _f = props.limit, limit = _f === void 0 ? -1 : _f, _g = props.limitAlertText, limitAlertText = _g === void 0 ? '' : _g, defaultLabel = props.defaultLabel, onSelected = props.onSelected;
    var propValue = props.value;
    var initValue = propValue || EMPTY_VALUE_ID;
    var prevPropValue = usePrevious(propValue);
    var _h = useState(initValue), value = _h[0], setValue = _h[1];
    var _j = useState(false), isModalOpen = _j[0], setModalOpen = _j[1];
    // Make value state reflect value prop when change
    // TODO: Not a prefered way of detect data update using Hooks
    useEffect(function () {
        if (propValue !== prevPropValue && propValue !== value) {
            setValue(propValue);
        }
    });
    /**
     * Handle actions when user click to select an option from Full Screen Modal
     *
     * @param selectedOption
     */
    var handleOptionSelected = function (selectedOption) {
        var selectedValue = selectedOption.id;
        if (mode === MobileSelectMode.Multiple) {
            selectedValue = __spreadArray([], value, true);
            if (selectedValue.includes(selectedOption.id)) {
                // remove
                selectedValue = selectedValue.filter(function (_item) { return _item !== selectedOption.id; });
            }
            else {
                selectedValue.push(selectedOption.id);
            }
        }
        else {
            setModalOpen(false);
        }
        setValue(selectedValue);
        onSelected && onSelected(selectedValue);
    };
    var handleCloseModal = function () { return setModalOpen(false); };
    var selectOptions = options;
    if (defaultLabel) {
        if (mode === MobileSelectMode.Single) {
            selectOptions = __spreadArray([
                {
                    id: EMPTY_VALUE_ID,
                    name: defaultLabel
                }
            ], options, true);
        }
    }
    var selectedLabel = ((_a = selectOptions.find(function (option) { return option.id === value; })) === null || _a === void 0 ? void 0 : _a.name) || '';
    var styleTag = styles.tag;
    if (mode === MobileSelectMode.Multiple) {
        // set style tags
        styleTag = styles.tag + ' ' + styles.multiple;
        // value label
        var valueArray_1 = value;
        var labelList = [];
        var _loop_1 = function (i) {
            var text = ((_b = selectOptions.find(function (_option) { return _option.id === valueArray_1[i]; })) === null || _b === void 0 ? void 0 : _b.name) || '';
            if (text !== '') {
                labelList.push(text);
            }
        };
        for (var i = 0; i < valueArray_1.length; i++) {
            _loop_1(i);
        }
        if (labelList.length > 0) {
            selectedLabel = labelList.join(', ');
            styleTag += ' ' + styles.active;
        }
        else {
            selectedLabel = defaultLabel || '';
        }
    }
    return (React__default.createElement("div", { className: styles.MobileSelect },
        React__default.createElement("div", { className: styles.title }, title),
        React__default.createElement("div", { className: styleTag, onClick: function () { return setModalOpen(true); } },
            React__default.createElement("span", { className: styles.labelText }, selectedLabel),
            React__default.createElement("span", { className: styles.tagIcon },
                React__default.createElement("svg", { fill: '#000000', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 30 30', width: '30px', height: '30px' },
                    React__default.createElement("path", { d: 'M12,27h-2c-0.386,0-0.738-0.223-0.904-0.572s-0.115-0.762,0.13-1.062L17.708,15L9.226,4.633 c-0.245-0.299-0.295-0.712-0.13-1.062S9.614,3,10,3h2c0.3,0,0.584,0.135,0.774,0.367l9,11c0.301,0.369,0.301,0.898,0,1.267l-9,11 C12.584,26.865,12.3,27,12,27z' })))),
        React__default.createElement(FullScreenModal, { isOpen: isModalOpen, options: selectOptions, selectedOptionId: value, onOptionSelected: handleOptionSelected, onBack: handleCloseModal, mode: mode === MobileSelectMode.Multiple ? FullScreenModalMode.Multiple : FullScreenModalMode.Single, limit: limit, limitAlertText: limitAlertText })));
};

export { MobileSelect as default };
//# sourceMappingURL=index.js.map
